import React, { useContext, useEffect, useState } from 'react';
import { AgendaStreamingContext } from '../../common/AgendaStreamingContextProvider';
import Betslip from '../../common/Betslip';
import FavoritesContextProvider from '../../common/FavoritesContextProvider';
import GoUpBtn from '../../common/GoUpBtn';
import GoUpParag from '../../common/GoUpParag';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { setAvailableSpaceForTables } from '../../tables-utils';
import { useLayout } from '../../UISettingsProvider';
import AgendaStreamingCompetition from '../common/AgendaStreamingCompetition';
import LiveSection from '../common/LiveSection';
import LiveSuiteCompetition from './LiveSuiteCompetition';
import LiveScoresDisclaimer from '../common/LiveScoresDisclaimer';

function LiveSuite(props) {
	const layout = useLayout();
	const agendaStreamingContext =  useContext(AgendaStreamingContext);
	const betslipContext = useContext(BetslipContext);

	// Abilita scrolling
    useEffect(function() {
		window.setHeight();
		setAvailableSpaceForTables();
    });

	useEffect(function() {
		agendaStreamingContext.setShowAgendaStreaming(props.openAgendaStreaming);
    },[props.openAgendaStreaming]);

	

    const [match, setMatch] = useState(null);
	const [showMatch, setShowMatch] = useState(false);

    function openMatch(match) {
        setMatch(match);
    }

	function showSelectedMatch() {
		setShowMatch(true);
	}

	function hideSelectedMatch() {
		setShowMatch(false);
	}

	return (
		<div className="container-fluid pagina-sport bg-grigio-chiaro padding-su-1x">
			<div className="row no-gutters sport-griglia">
				<div className={"griglia-centrale-sport col stringimento-sidebar "+ layout.order.divCentrale} id="div-centrale">
					<div className="contenitore-schedine-sport">
						<div className="competizione-interna dueColonne live-suite-cont">
							<div id="primo-blocco-sport" className="sport-blocco primo-blocco-sport go-up-arrow-on-overflow">
								<GoUpBtn />
                                <FavoritesContextProvider>
									<LiveSection openMatch={openMatch}
                                                 openMatchOnChange={true}
                                                 showSelectedMatch={showSelectedMatch}
                                                 hideSelectedMatch={hideSelectedMatch}
                                                 isLiveSuite={true}
                                                 moreBetsEnabled={false}
												 openFromPath={props.openFromPath} />
                                    <LiveScoresDisclaimer />
								</FavoritesContextProvider>
								<GoUpParag/>
							</div>
							{agendaStreamingContext.showAgendaStreaming ?
								<div id="secondo-blocco-sport" className="sport-blocco secondo-blocco-sport tablesCompacted go-up-arrow-on-overflow">
									<AgendaStreamingCompetition />
								</div>
							    :
                                <div id="secondo-blocco-sport" className="sport-blocco secondo-blocco-sport tablesCompacted go-up-arrow-on-overflow">
                                    {(showMatch && match != null) &&
                                        <>
                                            <GoUpBtn />
                                            <LiveSuiteCompetition match={match} />
                                        </>
                                    }
                                </div>
							}
						</div>
					</div>
				</div>
				{betslipContext.betslipData &&
                    <Betslip />
                }
			</div>
		</div>
	);
}
			
export default LiveSuite;